export const commonTemplates = {
  widget: {
    labels: {
      filters: {
        drawerFilterToggle: 'Filters',
        applyFilters: 'View products',
        clearAllFilters: 'Clear filters'
      }
    },
    options: {
      perPage: 28
    }
  },
  loader: {
    render(html) {
      return html`<div class="loading-indicator">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" xmlns:v="https://vecta.io/nano">
          <path
            fill-rule="evenodd"
            d="M16 2.6c7.401 0 13.4 6 13.4 13.4s-6 13.4-13.4 13.4-13.4-6-13.4-13.4 6-13.4 13.4-13.4zm-3.482 25.512c1.106.317 2.274.488 3.482.488s2.376-.171 3.481-.488L16 25.5l-3.482 2.611zm-1.781-.857c.009.064-.001.126-.021.184.303.14.611.271.926.387.027-.055.066-.105.118-.145l3.129-2.348a9.35 9.35 0 0 1-4.7-1.946l.548 3.868zm11.074-3.868c-1.326 1.044-2.937 1.739-4.7 1.946l3.13 2.348.06.056a.39.39 0 0 1 .058.089 12.52 12.52 0 0 0 .925-.386c-.02-.058-.028-.12-.018-.185l.547-3.868zM4.978 22.105c1.146 2.064 2.854 3.771 4.918 4.917l-.609-4.309-4.309-.608zm17.735.608l-.608 4.309c2.064-1.146 3.771-2.853 4.917-4.917l-4.309.608zM16 7.4a8.57 8.57 0 0 0-6.046 2.484c-.02.026-.043.049-.069.069A8.57 8.57 0 0 0 7.4 16a8.57 8.57 0 0 0 2.484 6.045.4.4 0 0 1 .073.073A8.57 8.57 0 0 0 16 24.6a8.57 8.57 0 0 0 6.041-2.481c.022-.029.048-.055.077-.077A8.57 8.57 0 0 0 24.6 16a8.57 8.57 0 0 0-2.481-6.042.4.4 0 0 1-.073-.073A8.57 8.57 0 0 0 16 7.4zM4.32 20.24c-.039.052-.09.09-.146.117a12.49 12.49 0 0 0 .386.925.4.4 0 0 1 .104-.021l.081.003 3.867.547a9.35 9.35 0 0 1-1.946-4.7L4.32 20.24zm21.012-3.13c-.207 1.763-.902 3.375-1.946 4.7l3.868-.547.081-.003a.4.4 0 0 1 .104.021 12.52 12.52 0 0 0 .386-.925.39.39 0 0 1-.089-.058l-.056-.06-2.348-3.13zM3.888 12.518C3.57 13.624 3.4 14.792 3.4 16s.17 2.376.487 3.481L6.499 16l-2.611-3.482zM25.5 16l2.611 3.481c.317-1.106.488-2.274.488-3.481s-.171-2.376-.488-3.482L25.5 16zM4.745 10.735c-.064.009-.127.001-.185-.019a12.53 12.53 0 0 0-.386.925c.032.016.063.034.09.059l.056.06 2.347 3.129a9.35 9.35 0 0 1 1.947-4.701l-3.869.548zm18.641-.547a9.35 9.35 0 0 1 1.946 4.7l2.348-3.129c.039-.052.09-.091.145-.118-.116-.315-.247-.623-.387-.926-.058.02-.119.03-.184.021l-3.868-.548zm-.673-.902l4.309.609c-1.146-2.064-2.853-3.772-4.917-4.918l.608 4.309zM9.895 4.978C7.831 6.123 6.123 7.831 4.978 9.895l4.308-.609.609-4.308zm1.747-.803a12.53 12.53 0 0 0-.925.386c.02.058.028.12.019.185l-.548 3.869a9.35 9.35 0 0 1 4.701-1.947L11.76 4.32l-.06-.056c-.024-.027-.043-.058-.059-.09zm8.716 0c-.027.055-.065.106-.117.146l-3.13 2.347a9.35 9.35 0 0 1 4.7 1.946l-.547-3.867-.003-.081a.4.4 0 0 1 .021-.104 12.49 12.49 0 0 0-.925-.386zM16 3.4c-1.208 0-2.376.17-3.482.487L16 6.499l3.481-2.611C18.376 3.57 17.208 3.4 16 3.4z"
            fill="currentColor"
          />
        </svg>
      </div>`;
    }
  },
  closeIcon: {
    render(html, { props: { onClick } }) {
      return html`
        <svg
          onclick=${onClick}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          class="icon close-icon"
          viewBox="0 0 18 17"
        >
          <path
            fill="currentColor"
            d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
          />
        </svg>
      `;
    }
  },
  filters: {
    options: {
      showFiltersInDrawer: true,
      showClearActionForIndividualFilters: false,
      expandTopNFiltersByDefault: true,
      showApplyFiltersButton: true
    },
    render(html, { props, labels, templates }) {
      const {
        helpers,
        showClearAllFilters,
        collapsible,
        showAppliedFilters,
        includeSortOptionsInFilters,
        showApplyFiltersButton
      } = props;
      const { filters: filterLabels } = labels;
      const filters = helpers.getFilters();
      const appliedFilters = helpers.getAppliedFilters(true);
      const showClearAllFiltersAction = showClearAllFilters && appliedFilters.length;
      const classes = ['filters'];
      if (collapsible) {
        classes.push('collapsible');
      }
      const className = classes.join(' ');
      const shopifyFallback = Tagalys.UIWidgets.hasFailedOver();
      return html`
        <div class=${className}>
          <div class="filters__container">
            <div class="filters-header__container">
              <${templates.filtersHeader} />
              ${showAppliedFilters ? html` <${templates.appliedFilters} /> ` : null}
            </div>
            <div class="filters__list">
              ${includeSortOptionsInFilters === 'top' ? html` <${templates.sortOptionInFilters} /> ` : null}
              ${filters.map((filterItem) => html`<${templates.filter} filter=${filterItem} />`)}
              ${includeSortOptionsInFilters === true || includeSortOptionsInFilters === 'bottom'
                ? html` <${templates.sortOptionInFilters} /> `
                : null}
            </div>

            <div class="filters__actions">
              ${showApplyFiltersButton
                ? html`<button
                    class="button button--primary button--orange button--full-width exclude-tagalys-css-reset"
                    onClick=${helpers.closeFilterDrawer}
                  >
                    ${filterLabels.applyFilters} ${!shopifyFallback ? html` (${helpers.getTotalProductsCount()}) ` : null}
                  </button>`
                : null}
              ${showClearAllFiltersAction
                ? html`
                    <button
                      class="button button--tertiary button--black exclude-tagalys-css-reset"
                      onclick=${helpers.clearAllFilters}
                    >
                      ${filterLabels.clearAllFilters}
                      <span class="svg-wrapper"><img src="${window.tagalysConfig.closeIcon}" alt="Close" /></span>
                    </button>
                  `
                : null}
            </div>
          </div>
        </div>
      `;
    }
  },
  filterHeader: {
    render(html, { props, labels, templates }) {
      const { helpers, filterId, filterHeading } = props;
      const { filters: filterLabels } = labels;
      const filterOptions = helpers.getTemplateOptions('filters');
      const showClearActionForIndividualFilters =
        filterOptions.showClearActionForIndividualFilters && helpers.isFilterApplied(filterId);
      const toggleCollapsibleFilter = () => {
        helpers.toggleCollapsibleFilter(filterId);
      };
      const clearFilter = (event) => {
        event.stopPropagation();
        helpers.clearFilter(filterId);
      };
      return html`
        <div onClick=${filterOptions.collapsible ? toggleCollapsibleFilter : undefined} class="filter-header">
          <div class="filter-actions">
            ${showClearActionForIndividualFilters
              ? html`
                  <div onClick=${clearFilter} class="filter-action-clear">${filterLabels.clearIndividualFilter}</div>
                `
              : null}
            <span class="filter-action-toggle-collapse">
              ${filterOptions.collapsible ? html` <${templates.downArrow} /> ` : null}
            </span>
          </div>
          <h3 class="filter-heading exclude-tagalys-css-reset body-sm body-uppercase font-medium">${filterHeading}</h3>
        </div>
      `;
    }
  },
  downArrow: {
    render(html) {
      return html`
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus down-arrow" viewBox="0 0 10 10">
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z"
            clip-rule="evenodd"
          />
        </svg>
      `;
    }
  },
  filterCheckBoxes: {
    render(html, { props, templates }) {
      const { filterId, filterItems } = props;
      return html`
        <ul class="filter-checkboxes checkbox-group exclude-tagalys-css-reset">
          ${filterItems.map((filterItem) => {
            return html`
                <${templates.checkboxFilterItem}
                  filterId=${filterId}
                  filterItem=${filterItem}
                >
                ${
                  filterItem.selected && filterItem.items
                    ? html` <${templates.filterCheckBoxes} filterId=${filterId} filterItems=${filterItem.items} /> `
                    : null
                }
              </${templates.checkboxFilterItem}>
            `;
          })}
        </ul>
      `;
    }
  },
  checkboxFilterItem: {
    render(html, { props }) {
      const { helpers, filterId, filterItem, showMatchingProductsCount, children } = props;
      const onFilterClick = (event) => {
        event.stopPropagation();
        if (filterItem.selected) {
          helpers.clearFilter(filterId, filterItem.id);
        } else {
          helpers.applyFilter(filterId, filterItem.id);
        }
      };
      return html`
        <li class="filter-item exclude-tagalys-css-reset" data-filter-item-id=${filterItem.id} onClick=${onFilterClick}>
          <span class="filter-checkbox-and-label exclude-tagalys-css-reset">
            <input class="checkbox" checked=${filterItem.selected} type="checkbox" />
            <label class="filter-item-label-and-count exclude-tagalys-css-reset">
              <span class="filter-item-label">${filterItem.label}</span>
              ${showMatchingProductsCount ? html` <span class="filter-item-count">(${filterItem.count})</span> ` : null}
            </label>
          </span>
          ${children}
        </li>
      `;
    }
  },
  rangeSliderFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;

      return html`
        <div class="range-slider filter-item" style="--currency-label: '${window.defaultTagalysCurrencyLabel}';">
          <div ref=${props.sliderRef} />
          <div class="input-group">
            <div class="input-container">
              <input
                class="exclude-tagalys-css-reset field__input"
                type="number"
                value=${props.sliderInputValues[0]}
                onblur=${props.onInputBlur}
                onchange=${props.onMinChange}
              />
            </div>
            <span class="to">${labels.filters.rangeFilterValueSeparator}</span>
            <div class="input-container">
              <input
                class="exclude-tagalys-css-reset field__input"
                type="number"
                value=${props.sliderInputValues[1]}
                onblur=${props.onInputBlur}
                onchange=${props.onMaxChange}
              />
            </div>
          </div>
        </div>
      `;
    }
  },
  infoAndActions: {
    render(html, { props, labels, templates }) {
      const { helpers } = props;
      const { filters: filterLabels, productListingPage, searchResults } = labels;
      const filterOptions = helpers.getTemplateOptions('filters');
      const appliedFilters = helpers.getAppliedFilters();
      const shopifyFallback = Tagalys.UIWidgets.hasFailedOver();

      // Remove console.log statement.
      const getProductsCountLabel = () => {

        if (shopifyFallback) {
          return '';
        }

        const labelTemplate = productListingPage?.productsCount ?? searchResults?.productsCount;
        if (!labelTemplate) {
          // Return empty string if no label template is found.
          return '';
        }
        return labelTemplate.replace('{{productsCount}}', helpers.getTotalProductsCount());
      };

      return html`
        <div class="plp-applied-filters">${appliedFilters.length ? html` <${templates.appliedFilters} /> ` : null}</div>
        <div class="plp-info-and-actions">
          <div class="info-and-filter-toggle">
            <button onclick=${helpers.openFilterDrawer} class="filter-drawer-toggle">
              ${filterLabels.drawerFilterToggle}
            </button>
          </div>
          <div class="results-count-wrapper"><div class="results-count">${getProductsCountLabel()}</div></div>
          ${filterOptions.includeSortOptionsInFilters ? null : html` <${templates.sortOptions} /> `}
        </div>
      `;
    }
  },
  sortOptions: {
    callbacks: {
      afterInitialRender: function () {
        document.querySelectorAll('.custom-select').forEach((customSelect) => {
          const selectButton = customSelect.querySelector('.select-button');
          const selectOptions = customSelect.querySelector('.select-options');
          const selectOptionsList = customSelect.querySelectorAll('.select-option');
          const nativeSelect = customSelect.querySelector('select');

          // Toggle dropdown
          selectButton.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = selectButton.classList.contains('active');

            // Close all other dropdowns
            document.querySelectorAll('.select-button').forEach((btn) => {
              btn.classList.remove('active');
            });
            document.querySelectorAll('.select-options').forEach((opts) => {
              opts.classList.remove('active');
            });

            if (!isActive) {
              selectButton.classList.add('active');
              selectOptions.classList.add('active');
            } else {
              selectButton.classList.remove('active');
              selectOptions.classList.remove('active');
            }
          });

          // Handle option selection
          selectOptionsList.forEach((option) => {
            option.addEventListener('click', (e) => {
              e.stopPropagation();

              const value = option.getAttribute('data-value');
              const text = option.textContent.trim();

              // Update button text
              selectButton.textContent = text;

              // Update native select
              nativeSelect.value = value;

              // Update visual selection
              selectOptionsList.forEach((opt) => opt.classList.remove('selected'));
              option.classList.add('selected');

              // Store value in custom select
              customSelect.setAttribute('data-value', value);

              // Close dropdown
              selectButton.classList.remove('active');
              selectOptions.classList.remove('active');

              // Trigger change event on native select
              nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });

          // Close dropdown when clicking outside
          document.addEventListener('click', () => {
            selectButton.classList.remove('active');
            selectOptions.classList.remove('active');
          });

          // Keyboard navigation
          selectButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              selectButton.click();
            }
          });

          // Sync with native select if it changes programmatically
          nativeSelect.addEventListener('change', () => {
            const selectedOption = Array.from(selectOptionsList).find(
              (opt) => opt.getAttribute('data-value') === nativeSelect.value
            );
            if (selectedOption) {
              selectButton.textContent = selectedOption.textContent.trim();
              selectOptionsList.forEach((opt) => opt.classList.remove('selected'));
              selectedOption.classList.add('selected');
            }
          });

          const defaultOption = Array.from(selectOptionsList).find(
            (opt) => opt.getAttribute('data-value') === nativeSelect.value
          );
          if (defaultOption) {
            selectButton.textContent = defaultOption.textContent.trim();
            defaultOption.classList.add('selected');
          }
        });
      }
    },
    render(html, { props, labels }) {
      const { helpers } = props;
      const { sortOptions: sortLabels } = labels;
      const sortOptions = helpers.getSortOptions();
      const appliedSortOption = helpers.getAppliedSortOption();
      const applySortOption = (event) => {
        helpers.applySortOption(event.target.value);
      };
      return html`
        <div class="sort-options-container exclude-tagalys-css-reset">
          <label class="sort-by-label body-sm body-uppercase font-medium" for="sort-options">
            ${sortLabels.sortBy} :
          </label>
          <div class="select custom-select">
            <select
              class="sort-options select__select body-sm body-uppercase font-medium"
              id="sort-options"
              value=${appliedSortOption.id}
              onchange=${applySortOption}
            >
              ${sortOptions.map((sortOption) => {
                return html` <option value=${sortOption.id}>${sortOption.label}</option>`;
              })}
            </select>
            <div class="select-button body-sm body-uppercase font-medium exclude-tagalys-css-reset">Select...</div>
            <div class="select-options exclude-tagalys-css-reset">
              ${sortOptions.map((sortOption) => {
                return html`
                  <div class="select-option body-sm body-uppercase font-medium" data-value=${sortOption.id}>
                    <div>${sortOption.label}</div>
                  </div>
                `;
              })}
            </div>
            <span class="svg-wrapper"><img src="${window.tagalysConfig.caretIcon}" alt="Caret" /></span>
          </div>
        </div>
      `;
    }
  },
  products: {
    callbacks: {
      afterInitialRender: function () {
        window.initProductRating();
        // Initialize product card modals for delivery badges.
        if (window.initProductCardModals) {
          window.initProductCardModals();
        }
      }
    },
    render(html, { props, templates }) {
      const { helpers, className } = props;
      const products = helpers.getProducts();
      const previousPage = helpers.hasPreviousPage();
      const appliedFilters = helpers.getAppliedFilters(true);
      return html`
        <div class=${`products ${className}`}>
          ${products.map((product) => html`<${templates.product} key=${product.id} product=${product} />`)}
          ${!previousPage && appliedFilters.length < 1
            ? html`<${templates.collectionPanels} collectionPanels=${window.tagalysConfig.collectionPanels} />`
            : null}
        </div>
      `;
    }
  },
  paginationLinks: {
    options: {
      showPreviousPageLink: false,
      showFirstPageLink: false,
      showNextPageLink: false
    }
  }
};

export const productCardTemplate = {
  product: {
    render(html, { props }) {
      const { product, helpers } = props;
      const {
        colorVariants = [],
        material = false,
        colourSwatch = false,
        colourSwatchImage = false,
        personalise,
        stickers = [],
        deliveryBadgeLabel = '',
        deliveryBadgeInfo = null,
        deliveryBadgeBackgroundColour = '',
        deliveryBadgeTextColour = ''
      } = product.metafields;

      const productSkus = product?.variants?.map((v) => v.sku).join(';') || '';
      const productIds = product?.variants?.map((v) => v.id).join(';') || '';

      let imagesCount = product.images.length;

      let secondImage = null;
      if (imagesCount > 1) {
        secondImage = product.images[1];
      }

      /* END metafields */
      const navigateToProductDetailPage = (event) => {
        helpers.navigateToProductDetailPage(event, product);
      };
      const productOptions = helpers.getTemplateOptions('product');
      const productLink = productOptions.productPageUrl(product);
      return html`
        <div class="product" onClick=${navigateToProductDetailPage}>
          <a class="product-link" href=${productLink}>
            <div class="product-image-container">
              ${product.featured_image
                ? html`<img
                    class="product-image product-image--primary"
                    data-src=${product.featured_image.src}
                    alt=${product.title}
                  />`
                : null}
              ${secondImage
                ? html`<img
                    class="product-image product-image--second"
                    data-src=${secondImage.src}
                    alt=${product.title}
                  />`
                : null}
              <div class="product-badges">
                ${stickers
                  .sort((a, b) => a.priority - b.priority)
                  .map((sticker) => {
                    const style = `background-color: ${sticker.colour}; color: ${sticker.textColour};`;
                    return html`<div class="product-badge" style=${style}>${sticker.label}</div>`;
                  })}
              </div>
              ${personalise ? html`<div class="product-personalise">Personalise</div>` : null}
            </div>
            <div class="product-details">
              <span class="product-name">${product.title}</span>
              ${helpers.isStorefrontAPICallPending()
                ? html`<span class="skeleton-box"></span>`
                : html`<span
                    class=${`product-prices${
                      helpers.isProductOnSale(product.compare_at_price, product.price) ? ' discounted' : ' full-price'
                    }`}
                  >
                    ${product.price_varies || personalise
                      ? html`<span class="product-price-from">${window.tagalysConfig.fromText}</span> `
                      : null}
                    <span class="product-price-regular">
                      ${helpers.formatCurrency(
                        product.compare_at_price === null || Number(product.compare_at_price) === 0
                          ? product.price
                          : product.compare_at_price
                      )}
                    </span>
                    ${helpers.isProductOnSale(product.compare_at_price, product.price)
                      ? html` <span class="product-price-discounted">${helpers.formatCurrency(product.price)}</span>
                          <span
                            class="product-price-savings${window.tagalysConfig?.showDiscountBadge
                              ? ' product-price-savings--badge'
                              : ''}"
                          >
                            Save
                            ${Math.round(
                              ((Number(product.compare_at_price) - Number(product.price)) /
                                Number(product.compare_at_price)) *
                                100
                            )}%
                          </span>`
                      : null}
                  </span>`}
              ${deliveryBadgeLabel
                ? html`
                    <div class="product-card__delivery-badge-wrapper exclude-tagalys-css-reset">
                      ${deliveryBadgeInfo
                        ? html`
                            <modal-opener
                              class="product-card__delivery-badge-opener exclude-tagalys-css-reset"
                              data-modal="#ProductDeliveryBadgeModal-${product.id}"
                            >
                              <button
                                type="button"
                                class="product-card__delivery-badge body-2xs font-medium exclude-tagalys-css-reset"
                                style="${deliveryBadgeTextColour
                                  ? `color: ${deliveryBadgeTextColour};`
                                  : ''} ${deliveryBadgeBackgroundColour
                                  ? `background-color: ${deliveryBadgeBackgroundColour};`
                                  : ''}"
                                aria-haspopup="dialog"
                                aria-label="Open delivery information modal"
                              >
                                ${deliveryBadgeLabel}
                                <span class="product-card__delivery-badge-icon exclude-tagalys-css-reset">
                                  <span
                                    class="svg-wrapper svg-wrapper--small exclude-tagalys-css-reset"
                                    style="${deliveryBadgeTextColour ? `color: ${deliveryBadgeTextColour};` : ''}"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M.833 8a7.167 7.167 0 1 1 14.334 0A7.167 7.167 0 0 1 .833 8ZM8.13 6.687a.98.98 0 0 1 .6.305c.18.2.233.429.253.591C9 7.725 9 7.891 9 8.04V11a.667.667 0 1 1-1.333 0V8a.667.667 0 1 1 0-1.333h.027c.132 0 .295 0 .436.02ZM8 4.667A.667.667 0 1 0 8 6a.667.667 0 0 0 0-1.333Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                </span>
                              </button>
                            </modal-opener>
                          `
                        : html`
                            <div class="product-card__delivery-badge body-2xs font-medium exclude-tagalys-css-reset">
                              ${deliveryBadgeLabel}
                            </div>
                          `}
                    </div>
                  `
                : null}
              <div class="product__color-variants product__color-variants--has-variants exclude-tagalys-css-reset">
                ${colourSwatchImage || (colorVariants && colorVariants.length > 0)
                  ? html` <div class="product__color-variants-swatches exclude-tagalys-css-reset">
                      ${colourSwatchImage
                        ? html`
                            <a
                              href="${productLink}"
                              class="product__color-variants-swatch-link exclude-tagalys-css-reset"
                            >
                              <img
                                src=${colourSwatchImage}
                                alt=${colourSwatch}
                                width="20"
                                height="20"
                                class="product__color-variants-swatch product__color-variants-swatch--active exclude-tagalys-css-reset"
                              />
                            </a>
                          `
                        : null}
                      ${colorVariants.map((colorVariant) => {
                        return html`
                          <a
                            href="/products/${colorVariant.productHandle}"
                            class="product__color-variants-swatch-link exclude-tagalys-css-reset"
                          >
                            <img
                              src=${colorVariant.image}
                              alt=${colorVariant.label}
                              width="20"
                              height="20"
                              class="product__color-variants-swatch exclude-tagalys-css-reset"
                            />
                          </a>
                        `;
                      })}
                    </div>`
                  : null}
                ${material || colourSwatch
                  ? html` <div class="product__color-variants-category exclude-tagalys-css-reset">
                      ${material
                        ? html`<span class="product__color-variants-value exclude-tagalys-css-reset">${material}</span>`
                        : null}
                      ${colourSwatch
                        ? html`<span class="product__color-variants-value exclude-tagalys-css-reset"
                            >${material ? html`|` : null} ${colourSwatch}</span
                          >`
                        : null}
                    </div>`
                  : null}
              </div>
              <div class="product-card__rating exclude-tagalys-css-reset">
                <div
                  class="product-rating-inline__content js-product-rating-inline product-rating-inline__content--card exclude-tagalys-css-reset"
                  data-sku="${product.handle};${productSkus};${productIds}"
                  style="display: none;"
                >
                  <div
                    class="product-rating-inline__stars product-rating-inline__stars--card js-rating-stars js-rating-stars--card exclude-tagalys-css-reset"
                  ></div>
                  <div class="product-rating-inline__text product-rating-inline__text--card exclude-tagalys-css-reset">
                    <span class="product-rating-inline__rating js-rating-value exclude-tagalys-css-reset">0.0</span>
                    <span class="product-rating-inline__count js-rating-count exclude-tagalys-css-reset"
                      >(0 reviews)</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </a>
          ${deliveryBadgeInfo
            ? html`
                <modal-dialog
                  id="ProductDeliveryBadgeModal-${product.id}"
                  class="product-card-modal js-product-card-modal exclude-tagalys-css-reset"
                  data-delivery-badge-content="${deliveryBadgeInfo.content
                    ? String(deliveryBadgeInfo.content).replace(/"/g, '&quot;')
                    : ''}"
                >
                  <div
                    role="dialog"
                    aria-label="Delivery Information"
                    aria-modal="true"
                    class="product-card-modal__content exclude-tagalys-css-reset"
                    tabindex="0"
                  >
                    <div class="product-card-modal__wrapper exclude-tagalys-css-reset">
                      <div class="product-card-modal__header exclude-tagalys-css-reset">
                        <h2 class="product-card-modal__header-title heading-2xl exclude-tagalys-css-reset">
                          ${deliveryBadgeInfo.title || 'Delivery Information'}
                        </h2>
                        <button
                          id="ModalClose-${product.id}"
                          type="button"
                          class="product-card-modal__toggle exclude-tagalys-css-reset"
                          aria-label="Close"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 17" class="icon">
                            <path
                              fill="currentColor"
                              d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                            />
                          </svg>
                        </button>
                      </div>
                      <div class="product-card-modal__container exclude-tagalys-css-reset">
                        <div class="product-card-modal__content-info rte exclude-tagalys-css-reset"></div>
                      </div>
                    </div>
                  </div>
                </modal-dialog>
              `
            : null}
        </div>
      `;
    }
  }
};
export const collectionWidgetTemplates = {
  header: {
    render(html) {
      return html``;
    }
  }
};
export const searchWidgetTemplates = {
  widget: {
    labels: {
      searchResults: {
        noResultsHeading: 'Sorry! No results found. Try clearing the filters or changing your input'
      },
      filters: {
        drawerFilterToggle: 'Filters',
        applyFilters: 'View products',
        clearAllFilters: 'Clear filters'
      }
    },
    options: {
      perPage: 28
    }
  }
};
export const searchSuggestionsTemplate = {
  widget: {
    options: {
      alignToSelector: '.header__search-modal-inner-content',
      inheritAlignmentElementWidth: true,
      sections: {
        products: {
          include: ['total_count', 'items'],
          count: 12
        },
        collections: {
          count: 10
        },
        searches: {
          count: 10
        },
        pages: {
          count: 0
        }
      }
    }
  }
};
export const searchSuggestionsFallbackTemplate = {
  widget: {
    options: {
      alignToSelector: '.header__search-modal-inner-content',
      inheritAlignmentElementWidth: true,
      sections: {
        products: {
          include: ['total_count', 'items'],
          count: 12
        },
        collections: {
          count: 10
        },
        queries: {
          count: 10
        },
        pages: {
          count: 0
        }
      }
    }
  }
};
export const shopifyFallbackWidgets = {
  pagination: {
    render: function (html, args) {
      var props = args.props
      var helpers = props.helpers
      if(helpers.canLoadNextResults(props.showLoadNextAfterEvery)){
        return html`<${args.templates.loadNext} />`;
      }
      return null
    },
  },
  loadNext: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels
      return html`
        <button class="button button--primary button--orange exclude-tagalys-css-reset" onclick=${props.helpers.loadNextPage}>
          ${helpers.isLoading() ? labels.pagination.loading : labels.pagination.loadNext}
        </button>
      `;
    }
  }
};

